// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_scribe_encounter.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum com.diagnocat.model.EncounterStatus
 */
export const EncounterStatus = proto3.makeEnum(
  "com.diagnocat.model.EncounterStatus",
  [
    {no: 0, name: "EncounterStatusInvalidValue"},
    {no: 1, name: "EncounterStatusAwaitingUpload"},
    {no: 2, name: "EncounterStatusRecording"},
    {no: 3, name: "EncounterStatusProcessingQueued"},
    {no: 4, name: "EncounterStatusProcessing"},
    {no: 5, name: "EncounterStatusCompleted"},
    {no: 6, name: "EncounterStatusFailed"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.FragmentStatus
 */
export const FragmentStatus = proto3.makeEnum(
  "com.diagnocat.model.FragmentStatus",
  [
    {no: 0, name: "FragmentStatusInvalidValue"},
    {no: 1, name: "FragmentStatusAwaitingUpload"},
    {no: 2, name: "FragmentStatusUploaded"},
    {no: 3, name: "FragmentStatusRecording"},
    {no: 4, name: "FragmentStatusStopped"},
    {no: 5, name: "FragmentStatusCompleted"},
    {no: 6, name: "FragmentStatusFailed"},
  ],
);

/**
 * Why a recording fragment left the recording state. InvalidValue means the
 * fragment predates the field (or never recorded) — treat as unknown.
 *
 * @generated from enum com.diagnocat.model.FragmentStopReason
 */
export const FragmentStopReason = proto3.makeEnum(
  "com.diagnocat.model.FragmentStopReason",
  [
    {no: 0, name: "FragmentStopReasonInvalidValue"},
    {no: 1, name: "FragmentStopReasonUser"},
    {no: 2, name: "FragmentStopReasonClientInterrupted"},
    {no: 3, name: "FragmentStopReasonStaleWatchdog"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.EncounterDocumentStatus
 */
export const EncounterDocumentStatus = proto3.makeEnum(
  "com.diagnocat.model.EncounterDocumentStatus",
  [
    {no: 0, name: "EncounterDocumentStatusInvalidValue"},
    {no: 1, name: "EncounterDocumentStatusPending"},
    {no: 2, name: "EncounterDocumentStatusGenerating"},
    {no: 3, name: "EncounterDocumentStatusSkipped"},
    {no: 4, name: "EncounterDocumentStatusCompleted"},
    {no: 5, name: "EncounterDocumentStatusFailed"},
    {no: 6, name: "EncounterDocumentStatusEdited"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.EncounterDocumentType
 */
export const EncounterDocumentType = proto3.makeEnum(
  "com.diagnocat.model.EncounterDocumentType",
  [
    {no: 0, name: "EncounterDocumentTypeInvalidValue"},
    {no: 1, name: "EncounterDocumentTypeSummary"},
    {no: 2, name: "EncounterDocumentTypeLetter"},
    {no: 3, name: "EncounterDocumentTypeFollowUpLetter"},
    {no: 4, name: "EncounterDocumentTypeProtocol"},
    {no: 5, name: "EncounterDocumentTypeEvaluation"},
    {no: 6, name: "EncounterDocumentTypeTemplate"},
    {no: 7, name: "EncounterDocumentTypeLiteratureReview"},
  ],
);

/**
 * DocumentationMode is the encounter-wide formatting hint the document
 * generator obeys. Unset is read as Protocol.
 *
 * @generated from enum com.diagnocat.model.DocumentationMode
 */
export const DocumentationMode = proto3.makeEnum(
  "com.diagnocat.model.DocumentationMode",
  [
    {no: 0, name: "DocumentationModeInvalidValue"},
    {no: 1, name: "DocumentationModeProtocol"},
  ],
);

/**
 * ModelType is the LLM tier the document generator runs against.
 *
 * @generated from enum com.diagnocat.model.ModelType
 */
export const ModelType = proto3.makeEnum(
  "com.diagnocat.model.ModelType",
  [
    {no: 0, name: "ModelTypeInvalidValue"},
    {no: 1, name: "ModelTypeFast"},
    {no: 2, name: "ModelTypeSmart"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.DocumentEditIssueType
 */
export const DocumentEditIssueType = proto3.makeEnum(
  "com.diagnocat.model.DocumentEditIssueType",
  [
    {no: 0, name: "DocumentEditIssueTypeInvalidValue"},
    {no: 1, name: "DocumentEditIssueTypeHallucination"},
    {no: 2, name: "DocumentEditIssueTypeOmission"},
    {no: 3, name: "DocumentEditIssueTypeWrongSection"},
    {no: 4, name: "DocumentEditIssueTypeOther"},
  ],
);

/**
 * @generated from message com.diagnocat.model.Encounter
 */
export const Encounter = proto3.makeMessageType(
  "com.diagnocat.model.Encounter",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DocumentationMode", kind: "enum", T: proto3.getEnumType(DocumentationMode) },
    { no: 9, name: "ModelType", kind: "enum", T: proto3.getEnumType(ModelType) },
    { no: 10, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterStatus) },
    { no: 12, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SchemaName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "Fragments", kind: "message", T: EncounterFragment, repeated: true },
    { no: 17, name: "Documents", kind: "message", T: EncounterDocument, repeated: true },
    { no: 18, name: "Analytics", kind: "message", T: Struct },
    { no: 19, name: "EvaluationOverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 27, name: "Abstract", kind: "message", T: EncounterAbstract, opt: true },
    { no: 20, name: "PatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 21, name: "ExtractedPatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 22, name: "ExtractedStaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 28, name: "StaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 29, name: "Archived", kind: "message", T: Archival, opt: true },
    { no: 23, name: "Deletion", kind: "message", T: Deletion, opt: true },
    { no: 24, name: "StartedAt", kind: "message", T: Timestamp, opt: true },
    { no: 25, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 26, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 10020, name: "YourPermissions", kind: "message", T: EncounterPermissions },
  ],
);

/**
 * EncounterPreview is the list projection of Encounter: no fragments,
 * documents or analytics, plus a summed audio duration.
 *
 * @generated from message com.diagnocat.model.EncounterPreview
 */
export const EncounterPreview = proto3.makeMessageType(
  "com.diagnocat.model.EncounterPreview",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DocumentationMode", kind: "enum", T: proto3.getEnumType(DocumentationMode) },
    { no: 9, name: "ModelType", kind: "enum", T: proto3.getEnumType(ModelType) },
    { no: 10, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterStatus) },
    { no: 12, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SchemaName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "EvaluationOverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 25, name: "Abstract", kind: "message", T: EncounterAbstract, opt: true },
    { no: 17, name: "PatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 18, name: "ExtractedPatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 19, name: "ExtractedStaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 26, name: "StaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 27, name: "Archived", kind: "message", T: Archival, opt: true },
    { no: 20, name: "Deletion", kind: "message", T: Deletion, opt: true },
    { no: 21, name: "TotalAudioDurationNS", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "StartedAt", kind: "message", T: Timestamp, opt: true },
    { no: 23, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 24, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 10020, name: "YourPermissions", kind: "message", T: EncounterPermissions },
  ],
);

/**
 * EncounterPermissions is what the caller may do with the encounter carrying it.
 *
 * @generated from message com.diagnocat.model.EncounterPermissions
 */
export const EncounterPermissions = proto3.makeMessageType(
  "com.diagnocat.model.EncounterPermissions",
  () => [
    { no: 1, name: "CanViewEvaluation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "CanArchive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "CanRestore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "CanDelete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * EncounterAbstract is the executive summary generated from the encounter's
 * completed summary documents. Status tracks the generation call.
 *
 * @generated from message com.diagnocat.model.EncounterAbstract
 */
export const EncounterAbstract = proto3.makeMessageType(
  "com.diagnocat.model.EncounterAbstract",
  () => [
    { no: 1, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterDocumentStatus) },
    { no: 3, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 5, name: "UpdatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterFragment
 */
export const EncounterFragment = proto3.makeMessageType(
  "com.diagnocat.model.EncounterFragment",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(FragmentStatus) },
    { no: 3, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Audio", kind: "message", T: StoredAudio, opt: true },
    { no: 5, name: "Transcript", kind: "message", T: Transcript, opt: true },
    { no: 6, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 7, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 8, name: "StopReason", kind: "enum", T: proto3.getEnumType(FragmentStopReason) },
  ],
);

/**
 * @generated from message com.diagnocat.model.StoredAudio
 */
export const StoredAudio = proto3.makeMessageType(
  "com.diagnocat.model.StoredAudio",
  () => [
    { no: 1, name: "URL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Duration", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "ContentType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "FileName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.Transcript
 */
export const Transcript = proto3.makeMessageType(
  "com.diagnocat.model.Transcript",
  () => [
    { no: 1, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Chunks", kind: "message", T: TranscriptChunk, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.TranscriptChunk
 */
export const TranscriptChunk = proto3.makeMessageType(
  "com.diagnocat.model.TranscriptChunk",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Start", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "End", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterDocument
 */
export const EncounterDocument = proto3.makeMessageType(
  "com.diagnocat.model.EncounterDocument",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TemplateSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Type", kind: "enum", T: proto3.getEnumType(EncounterDocumentType) },
    { no: 9, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterDocumentStatus) },
    { no: 10, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "UserEditable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "Sections", kind: "message", T: EncounterDocumentSection, repeated: true },
    { no: 13, name: "References", kind: "message", T: LiteratureReference, repeated: true },
    { no: 14, name: "OverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 24, name: "RequiresApproval", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "Approved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "ApprovedAt", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "ApprovedByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "GenerationModel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "GenerationModelType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "GenerationModelName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "GenerationModelProvider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 23, name: "UpdatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterDocumentSection
 */
export const EncounterDocumentSection = proto3.makeMessageType(
  "com.diagnocat.model.EncounterDocumentSection",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "UserContent", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "EditFeedback", kind: "message", T: DocumentEditFeedback, repeated: true },
  ],
);

/**
 * DocumentEditFeedback records why a user rewrote a section.
 *
 * @generated from message com.diagnocat.model.DocumentEditFeedback
 */
export const DocumentEditFeedback = proto3.makeMessageType(
  "com.diagnocat.model.DocumentEditFeedback",
  () => [
    { no: 1, name: "IssueType", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), opt: true },
    { no: 2, name: "IssueTypes", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), repeated: true },
    { no: 3, name: "OtherText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PreviousContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "NewContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.LiteratureReference
 */
export const LiteratureReference = proto3.makeMessageType(
  "com.diagnocat.model.LiteratureReference",
  () => [
    { no: 1, name: "Index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Authors", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Year", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "Journal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Abstract", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "PMID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DOI", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.PersonalInfo
 */
export const PersonalInfo = proto3.makeMessageType(
  "com.diagnocat.model.PersonalInfo",
  () => [
    { no: 1, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FullName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "DateOfBirth", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "PhoneNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Archival records who archived an encounter. Exactly one of ByUserID /
 * ByAPIKeyID is set, depending on how the caller authenticated.
 *
 * @generated from message com.diagnocat.model.Archival
 */
export const Archival = proto3.makeMessageType(
  "com.diagnocat.model.Archival",
  () => [
    { no: 1, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ByAPIKeyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "At", kind: "message", T: Timestamp },
  ],
);

/**
 * Deletion records who deleted an encounter. Exactly one of ByUserID /
 * ByAPIKeyID is set, depending on how the caller authenticated.
 *
 * @generated from message com.diagnocat.model.Deletion
 */
export const Deletion = proto3.makeMessageType(
  "com.diagnocat.model.Deletion",
  () => [
    { no: 1, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ByAPIKeyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "At", kind: "message", T: Timestamp },
  ],
);

